import { render, staticRenderFns } from "./inquireName.vue?vue&type=template&id=a9089f00&scoped=true&"
import script from "./inquireName.vue?vue&type=script&lang=js&"
export * from "./inquireName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9089f00",
  null
  
)

export default component.exports